import React from "react";
import styles from "./BillBox.module.scss";
import { MemberBox } from "@logora/parliament.parliament_member.member_box";

interface BillBoxProps {
	/** Extra className */
	className?: string;
	/** Bill */
	resource: BillProps;
	/** Hide status */
	hideStatus?: boolean;
}

interface BillProps {
	titre: string;
	uid: string;
	numero: string;
	dateDepot: string;
	typeInitiative: string;
	acteurPrincipalRef: {
		prenom: string;
		nom: string;
		urlImage: string;
        chambre?: string | undefined;
		groupeParlementaire?: {
			couleurAssociee: string;
			libelleAbrege: string;
		};
	} | null;
	documentDeposeRef?: {
		auteurPrincipal: {
			prenom: string;
			nom: string;
			urlImage: string;
			chambre?: string | undefined;
			groupeParlementaire?: {
				couleurAssociee: string;
				libelleAbrege: string;
			};
		};
	};
	rapporteurs?: {
		acteurRef: {
			prenom: string;
			nom: string;
			urlImage: string;
			chambre?: string | undefined;
			groupeParlementaire?: {
				couleurAssociee: string;
				libelleAbrege: string;
			};
		}
	}[];
	statut: string;
}

export const BillBox = ({ className, resource, hideStatus }: BillBoxProps) => {
	const auteur = resource.acteurPrincipalRef || resource.documentDeposeRef?.auteurPrincipal || resource.rapporteurs?.[0].acteurRef;

	return (
		<a
			href={`/#/parliament/dossiers/${resource.uid}`}
			className={`${styles.billBoxContainer} ${className}`}
		>
			<div className={styles.billBoxTitleContainer}>
				<span className={styles.billBoxType}>{resource.typeInitiative}</span>
				<span className={styles.billBoxTitle}>{`N°${resource.numero} · `}</span>
				<span className={styles.billBoxDate}>
					Déposé le{" "}
					{new Date(resource.dateDepot).toLocaleDateString("fr-FR", {
						day: "2-digit",
						month: "long",
						year: "numeric",
					})}
				</span>
			</div>
			<div className={styles.billBoxName}>{resource.titre}</div>
			{auteur && (
				<MemberBox
					firstName={auteur?.prenom}
					lastName={auteur?.nom}
					imageUrl={auteur?.urlImage}
					size="small"
					layout="oneLine"
					{...(auteur?.groupeParlementaire && {
						parliamentGroup: {
							groupName: auteur.groupeParlementaire.libelleAbrege,
							color: auteur.groupeParlementaire.couleurAssociee,
						},
					})}
					{...(auteur?.chambre !== undefined && { chamber: auteur.chambre })}
				/>
			)}
			{!hideStatus && (
				<div className={styles.billBoxStatus}>{resource.statut}</div>
			)}
		</a>
	);
};
